import {TweenMax, Linear} from "gsap";
import EventEmitter = require("eventemitter3");
import $ = require("jquery");

abstract class AbstractView {

    public id: number;
    public $template: JQuery;
    public emitter: EventEmitter;
    public children: any;
    public hasIn: boolean;

    public static ViewEvent: any = {
        ScrollTo: "SCROLL_TO",
        PlayVideo: "PLAY_VIDEO",
        LanguageChange: "LANGUAGE_CHANGE",
        TransitionInCompleted: "TRANSITION_IN_COMPLETED",
        TransitionOutCompleted: "TRANSITION_OUT_COMPLETED",
    };

    constructor(id: number = -1, selector: JQuery) {

        this.id = id;
        this.$template = selector;
        this.emitter = new EventEmitter();
        this.hasIn = false;
        this.children = {};
        this.init();
    }

    public init(): void {

    }

    public remove(): void {
    }

    public reset(): void {
    }

    public update(): void {
        if (this.children && Object.keys(this.children).length > 0) {
            for (let property in this.children) {
                if (this.children.hasOwnProperty(property)) {
                    let child: any = this.children[property].instance();
                    child.update();
                }
            }
        }
    }

    public resize(): void {
        if (this.children && Object.keys(this.children).length > 0) {
            for (let property in this.children) {
                if (this.children.hasOwnProperty(property)) {
                    let child: any = this.children[property].instance();
                    child.resize();
                }
            }
        }
    }

    public onScroll(containerTop: number): void {

    }

    public addRenderChild(child: any): void {
        let key: string = child.constructor["name"];
        this.children[key] = child;
    }

    public getChildBySelector(selector: string): JQuery {
        return this.$template.find(selector);
    }

    public getId(): number {
        return this.id;
    }

}

export = AbstractView;

